import { css } from "../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      maxWidth: "712px",
      margin: "0 auto",
      "& h2": {
        textAlign: "center",
      },
      "& ul": {
        display: "flex",
        flexDirection: "column",
        maxWidth: "350px",
        marginTop: "baseUnit.mobile2",
        marginX: "auto",
        marginBottom: 0,
        tablet: {
          display: "grid",
          gridTemplateColumns: "repeat(2, fit-content(350px))",
          justifyContent: "center",
          columnGap: "baseUnit.mobile6",
          rowGap: "baseUnit.mobile1",
          maxWidth: "712px",
          marginTop: "baseUnit.mobile3",
        },
      },
      "& li": {
        listStyle: "none",
        marginBottom: "baseUnit.mobile1",
        alignContent: "center",
        display: "flex",
        tablet: {
          marginBottom: 0,
          paddingRight: 0,
        },
      },
    }),

  buttonWrapper: () =>
    css({
      display: "flex",
      marginTop: "baseUnit.mobile3",
      marginX: "auto",
      marginBottom: 0,
      justifyContent: "center",
      tablet: {
        display: "none",
      },
    }),
  buttonInner: () =>
    css({
      display: "flex",
      alignItems: "center",
    }),
  icon: (showMore: boolean) =>
    css({
      border: "solid",
      borderWidth: "0 2px 2px 0",
      display: "inline-block",
      padding: "3px",
      transform: showMore ? "rotate(45deg)" : "rotate(225deg)",
      marginTop: showMore ? "-3px" : "5px",
      marginLeft: "baseUnit.mobile1",
    }),
  hideOnMobile: () =>
    css({
      display: "none",
      tablet: {
        display: "flex",
      },
    }),
  showOnMobile: () =>
    css({
      display: "flex",
      tablet: {
        display: "none",
      },
    }),
  collapseWrapper: () =>
    css({
      maxWidth: "350px",
      margin: "0 auto",
      tablet: {
        display: "none",
      },
      "& ul": {
        marginTop: 0,
      },
    }),
};
